import { IllegalOperationException } from '../exceptions/illegal-operation-exception.js';

export class Completer<T> {
  public readonly promise: Promise<T>;

  private _isCompleted = false;
  private _reject?: (reason?: unknown) => void;
  private _resolve?: (value: (PromiseLike<T> | T)) => void;

  public constructor() {
    this.promise = new Promise<T>((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  get isCompleted(): boolean {
    return this._isCompleted;
  }

  complete(value: (PromiseLike<T> | T)): void {
    if(this._resolve) {
      if(!this._isCompleted) {
        this._isCompleted = true;
        this._resolve(value);
      }
      else {
        throw new IllegalOperationException('Cannot complete a promise that has already been completed.');
      }
    }
    else {
      throw new IllegalOperationException('Completer is not yet initialized.');
    }
  }

  reject(reason?: unknown): void {
    if(this._reject) {
      if(!this._isCompleted) {
        this._isCompleted = true;
        this._reject(reason);
      }
      else {
        throw new IllegalOperationException('Cannot reject a promise that has already been completed.');
      }
    }
    else {
      throw new IllegalOperationException('Completer is not yet initialized.');
    }
  }
}
